import { Link, withRouter } from "react-router-dom"
import { motion } from 'framer-motion'
import img1 from '../images/undraw_Process_re_gws7.svg'
import img2 from '../images/undraw_Personal_settings_re_i6w4.svg'
import LogoImg from './LogoImg'
import { ImHome } from 'react-icons/im'
import { GoSignOut } from 'react-icons/go'
import { AiOutlineMenuFold } from 'react-icons/ai'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { useCallback, useEffect, useLayoutEffect, useMemo, useState, useRef } from "react"
import { TextAnimateXRev, TextAnimateY, wrapAnim } from "../commons/anims"
import FlowText from "./snippets/FlowText"
import DarkModeSwitch from './snippets/DarkModeSwitch'
import { useDispatch, useSelector } from "react-redux"
import { setLoggedIn } from "../store/auth/actions"
import { CombinedRoutes } from "../data/Routes/Routes"
import { HomeMenu } from "../data/HomeMenu"
import { setSidebar } from "../store/theme/actions"
import OrganizationSelector from "./OrganizationSelector"
import ReportSelector from "./ReportSelector"
import Dialog from "./snippets/Dialog"
import AddReferral from "../pages/Dialogs/AddReferral"
import { useTranslation } from 'react-i18next'
import { useMsal } from "@azure/msal-react";
import LanguageChange from "./LanguageChange"



const intialAnime = {
    hidden: {
        x: '-100vw',
        opacity: 0
    },
    visible: {
        x: 0,
        opacity: 1,
        transition: {
            type: 'easeOut',
            duration: 0.8
        }
    }
}
let xStart = 0;
let yStart = 0;

const SideBar = ({ history }) => {

    const [highlighted, setHighlighted] = useState('Cases')
    const sideBar = useSelector(state => state.theme.sideBar)
    const [sideBarExpanded, setSideBarExpanded] = useState(false)
    const dispatch = useDispatch()
    const userDetails = useSelector(state => state.auth.userDetails)
    const [addReferralDialog, setAddReferralDialog] = useState(false)
    const linkRefs = useRef(null);
    const { t } = useTranslation()
    let upload = localStorage.getItem('uploads')
    let noCaregiver = localStorage.getItem('noCaregiver')
    const organization = useSelector(state => state.auth.organization)
    let service = localStorage.getItem('bulkService')
    const serviceUsage = useSelector(state =>state.auth.serviceUsage)
    const filteredCombinedRoutes = useMemo(() => (
        CombinedRoutes.filter(c => c.roles === undefined || c.roles.some(e => userDetails !== undefined && userDetails.role !== undefined && userDetails?.role.includes(e)))
    ), [userDetails])// eslint-disable-line
    const { instance } = useMsal();

        const HomeMenuList = useMemo(() => {
      return  HomeMenu.filter(c => c.sidebar)
        .filter(c => {
            if(c.title === 'Add New') {
                if((userDetails.orgId !== parseInt(organization) && userDetails.role.includes('dynamic_cm')) || (userDetails.orgId !== parseInt(organization) && userDetails.role.includes('dynamic_ref'))){
                    return true
                } 
                else if((userDetails.orgId === parseInt(organization) && (service === 'true') && userDetails.parentRole.length === 1  && (userDetails.parentRole.includes('admin')))){
                    return true
                }
                else if((userDetails.orgId !== parseInt(organization) && userDetails.childRole.length === 1 &&  (service === 'true') && (userDetails.childRole.includes('dynamic_admin')))){
                    return true
                }
                else if((userDetails.parentRole.length === 1 && (userDetails.parentRole.includes('admin') || userDetails.parentRole.includes('screener')))){
                    return false
                }
                else if(userDetails.orgId !== parseInt(organization)){
                    return false
                }
                 
            }
            return true 
        })
            
    },[organization,userDetails,serviceUsage])// eslint-disable-line
    
    const logout = () => {
        if(userDetails.authType === 'sso') {
            instance.logoutRedirect({
                // postLogoutRedirectUri: "/",
                // mainWindowRedirectUri: "/"
            });
        }
        dispatch(setLoggedIn(false))
    }
    const isPathIcon = (title) => {
        if (history.location.pathname !== '/') {
            for (let route of filteredCombinedRoutes) {
                if (history.location.pathname.includes(route.link) && route.menu === title) return true
            }
        }
        return false
    }
    const selectedMainMenu = useMemo(() => {
        return HomeMenuList.find(c => c.title === highlighted)
    }, [highlighted])// eslint-disable-line
    const hasMenuItems = useCallback((title) => {
        let menu = HomeMenuList.find(c => c.title === title)
        return menu ? filteredCombinedRoutes.filter(c => c.menu === menu.title).length > 0 : false
    }, [HomeMenuList, filteredCombinedRoutes])
    const sideMenuList = useMemo(() => {
        let menu = HomeMenuList.find(c => c.title === highlighted)
        return menu ? filteredCombinedRoutes.filter(c => c.menu === menu.title) : []
    }, [highlighted])// eslint-disable-line
    const hideSidebar = () => dispatch(setSidebar(false))
    const showSideBar = () => dispatch(setSidebar(true))
    const dragStart = ev => {
        if (ev.changedTouches === undefined) return
        xStart = ev.changedTouches[0].screenX
        yStart = ev.changedTouches[0].screenY
    }
    const dragEnd = ev => {
        if (ev.changedTouches === undefined) return
        let xEnd = ev.changedTouches[0].screenX
        if (Math.abs(yStart - ev.changedTouches[0].screenY) > 100) return
        let diff = xStart - xEnd
        if (xStart > window.innerWidth / 2 && diff > 150) hideSidebar()
        else if (xStart < 1000 && diff < -150) showSideBar()
    }
    const setHighlightedMenu = () => {
        let found = false
        filteredCombinedRoutes.forEach((c, i) => {
            if (c.link === history.location.pathname) {
                if (!c.menu) return
                found = true
                setHighlighted(c.menu)
            }
        })
        if (!found) setHighlighted(HomeMenuList[0].title)
    }
    const expandSideBar = () => setSideBarExpanded(true)
    const shrinkSideBar = () => setSideBarExpanded(false)

    useEffect(() => {
        hideSidebar()
    }, [history.location.pathname]) // eslint-disable-line
    // set initially highlighted
    useEffect(() => {
        if (!sideBarExpanded)
            setHighlightedMenu()
    }, [sideBarExpanded]) // eslint-disable-line
    useEffect(() => setHighlightedMenu(), []) // eslint-disable-line
    useLayoutEffect(() => {
        window.addEventListener('touchstart', dragStart)
        window.addEventListener('dragstart', dragStart)
        window.addEventListener('touchend', dragEnd)
        window.addEventListener('dragend', dragEnd)

        return () => {
            window.removeEventListener('touchstart', dragStart)
            window.removeEventListener('dragstart', dragStart)
            window.removeEventListener('touchend', dragEnd)
            window.removeEventListener('dragend', dragEnd)

        }
    }, []) // eslint-disable-line

    const handleIconFocus = (value, myTile) => {
        setHighlighted(myTile)
        setSideBarExpanded(value);
    }

    const leftArrowFocus = (data) => {
        document.getElementById(data).focus();
    }
    const handleKeyDown  = (event) => {
      if(event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === 'ArrowLeft' || event.key === 'Enter') {
      const elements = linkRefs.current.querySelectorAll('a');
      const currentElementIndex = Array.from(elements).indexOf(event.target);
      let nextElementIndex;
      if (event.key && event.key !== undefined){
        if(event.key ==='Enter'){
            const href = elements[currentElementIndex]?.getAttribute('href')
            if (href) {
                history.push(href)
                shrinkSideBar()
            }
        } else if (event.key === 'ArrowRight') {
            nextElementIndex = (currentElementIndex + 1) % elements.length;
            elements[nextElementIndex]?.focus();
          } else if (event.key === 'ArrowDown') {
            const nextIndex = (currentElementIndex + 1) % elements.length;
            elements[nextIndex]?.focus();
            event.preventDefault();
          } else if (event.key === 'ArrowLeft') {
            linkRefs?.current?.addEventListener('keydown', leftArrowFocus(highlighted));
          }
          else if (event.key === 'ArrowUp') {
            nextElementIndex = (currentElementIndex - 1 + elements.length) % elements.length;
            elements[nextElementIndex]?.focus();
          }
        } 
       
      }
      
    }

    const [closeLanguage, setCloseLanguage] = useState(false)
    const [closeOrg, setCloseOrg] = useState(false)
    const selectCallBack = (val) => {
        if (val === 'language') {
            setCloseOrg(true)
            setCloseLanguage(false)
        } else if (val === 'organization') {
            setCloseLanguage(true)
            setCloseOrg(false)
        }else if (val === 'report' || val === 'theme'){
            setCloseLanguage(true)
            setCloseOrg(true)
        } 
        else {
            setSideBarExpanded(false)
        }
    }

    return (
        <>
            <div className="hidden lg:block md:w-[56px] flex-shrink-0"></div>
            <div className={`w-[320px] ${sideBarExpanded ? '' : 'lg:w-[56px]'} bg-bluegray-200 dark:bg-ddark flex flex-col items-center h-full shadow-xl flex-shrink-0 fixed lg:left-0 top-0 bottom-0 z-10 transition-all duration-200 ${sideBar ? 'left-0' : '-left-96'}`} onMouseEnter={expandSideBar} onMouseLeave={shrinkSideBar} >
                <div className="border-b w-full border-blue-200 dark:border-gray-700 flex justify-center py-4 items-center h-[80px] relative">
                    <Link to="/" onBlur={()=>document.removeEventListener('focus',shrinkSideBar())}>
                        <LogoImg size={sideBarExpanded || sideBar ? '120px' : '40px'} symbol={!sideBarExpanded && !sideBar} />
                    </Link>
                    <AiOutlineMenuFold size="25px" className="absolute right-5 cursor-pointer text-tcolor dark:text-white lg:hidden" onClick={hideSidebar} />
                </div>
                <motion.div variants={wrapAnim} initial="hidden" animate="visible" className="flex w-full overflow-y-auto overflow-x-hidden h-full relative">
                    <div className="h-full flex flex-col justify-center border-r border-blue-200 dark:border-gray-700 w-14 flex-shrink-0 z-20" ref={linkRefs}>
                        {
                            userDetails.role && userDetails.role.length === 1 &&  userDetails.role.includes('developer') ? <div className="flex-1 flex flex-col justify-start">
                                {HomeMenuList.map((c,i)=>{
                                    if(c.title === 'Swagger' && userDetails.role && (userDetails.role.includes('developer'))){
                                        return (
                                            <Link to="/">
                                                <motion.span key={i} variants={intialAnime} className={`flex my-0.5 justify-center cursor-pointer group relative rounded-2xl mx-1 ${isPathIcon(c.title) || history.location.pathname === c.link ? 'bg-tcolor text-white' : highlighted === c.title ? 'text-tcolor dark:text-gray-200' : 'text-gray-600 dark:text-gray-400'}`} onMouseEnter={() => c.extendSidebar === false ? '' : setHighlighted(c.title)} onClick={() => setHighlighted(c.title)} title={t(c.subtitle)}>
                                                    <c.TitleIcon size="22px" className={`my-3`} />
                                                </motion.span>
                                            </Link>
                                        )
                                    } return null;
                                })}
                            </div> : 
                            <div className="flex-1 flex flex-col justify-start">
                           { userDetails.role.length === 1 && userDetails.role.includes('developer') ? '':<Link to="/">
                                <motion.span variants={TextAnimateY} className={`flex justify-center cursor-pointer group relative  py-3 my-6 rounded-2xl mx-1 ${history.location.pathname === '/' ? 'bg-tcolor text-white' : 'text-gray-600 dark:text-gray-400'}`} title={t("Dashboard")}>
                                    <ImHome size="22px" className=" group-hover:animate-pulse" />
                                </motion.span>
                            </Link>}
                            {
                                HomeMenuList.filter(c => hasMenuItems(c.title)).map((c, i) => {
                                    if(c.roles.length === 0  && userDetails && userDetails.role && userDetails.role.length === 1 && userDetails.role.includes('developer') && parseInt(organization) !== userDetails.orgId){
                                        if(c.title === 'Settings'){
                                            return ''
                                        }else{
                                            return (
                                                <motion.span key={i} variants={intialAnime} className={`flex my-0.5 justify-center cursor-pointer group relative rounded-2xl mx-1 ${isPathIcon(c.title) || history.location.pathname === c.link ? 'bg-tcolor text-white' : highlighted === c.title ? 'text-tcolor dark:text-gray-200' : 'text-gray-600 dark:text-gray-400'}`} onMouseEnter={() => c.extendSidebar === false ? '' : setHighlighted(c.title)} onClick={() => setHighlighted(c.title)} title={t(c.subtitle)}>
                                                        <c.TitleIcon size="22px" className={`my-3`} />
                                                    </motion.span>
                                            )
                                        }
                                    }
                                    else if(c.roles.length > 0 && userDetails.role && userDetails.role.includes('referrer')){
                                        return (
                                            <Link key={`${i}`} to={c.link} className="block z-10 my-1 text-left">
                                                <motion.span key={i} variants={intialAnime} className={`flex my-0.5 justify-center cursor-pointer group relative rounded-2xl mx-1 ${isPathIcon(c.title) || history.location.pathname === c.link ? 'bg-tcolor text-white' : highlighted === c.title ? 'text-tcolor dark:text-gray-200' : 'text-gray-600 dark:text-gray-400'}`} onMouseEnter={() => c.extendSidebar === false ? '' : setHighlighted(c.title)} onClick={() => c.extendSidebar === false ? '' : setHighlighted(c.title)} title={t(c.subtitle)}>
                                                    <c.TitleIcon size="22px" className={`my-3`} />
                                                </motion.span>
                                            </Link>
                                        )
                                    }else if(c.title === 'Swagger' && userDetails.role && (userDetails.role.length === 1 && userDetails.role.includes('developer'))){
                                        return (
                                            <Link key={`${i}`} to={c.link} className="block z-10 my-1 text-left">
                                                <motion.span key={i} variants={intialAnime} className={`flex my-0.5 justify-center cursor-pointer group relative rounded-2xl mx-1 ${isPathIcon(c.title) || history.location.pathname === c.link ? 'bg-tcolor text-white' : highlighted === c.title ? 'text-tcolor dark:text-gray-200' : 'text-gray-600 dark:text-gray-400'}`} onMouseEnter={() => c.extendSidebar === false ? '' : setHighlighted(c.title)} onClick={() => c.extendSidebar === false ? '' : setHighlighted(c.title)} title={t(c.subtitle)}>
                                                    <c.TitleIcon size="22px" className={`my-3`} />
                                                </motion.span>
                                            </Link>
                                        )
                                          
                                   }else if(c.roles.length === 0){
                                        if(c.title === 'Swagger' && userDetails.role && (userDetails.role.includes('superadmin') || userDetails.role.includes('developer'))){
                                            return (
                                                <motion.span key={i} variants={intialAnime} className={`flex my-0.5 justify-center cursor-pointer group relative rounded-2xl mx-1 ${isPathIcon(c.title) || history.location.pathname === c.link ? 'bg-tcolor text-white' : highlighted === c.title ? 'text-tcolor dark:text-gray-200' : 'text-gray-600 dark:text-gray-400'}`} onMouseEnter={() => c.extendSidebar === false ? '' : setHighlighted(c.title)} onClick={() => setHighlighted(c.title)} title={t(c.subtitle)}>
                                                        <c.TitleIcon size="22px" className={`my-3`} />
                                                    </motion.span>
                                            )
                                        }else{
                                           if(c.title !== 'Swagger'|| (userDetails.role.includes('developer'))){
                                            return (
                                                <Link key={i}
                                                    onClick={() => setHighlighted(c.title)}
                                                    title={c.subtitle}
                                                    id={c.title}
                                                    to="/"
                                                    onKeyDown ={(event) => handleKeyDown(event, c.title)}  
                                                    onFocus={(event) => { handleIconFocus(true, c.title) }}
                                                >
                                                    <motion.span key={i} variants={intialAnime} className={`flex my-0.5 justify-center cursor-pointer group relative rounded-2xl mx-1 ${isPathIcon(c.title) || history.location.pathname === c.link ? 'bg-tcolor text-white' : highlighted === c.title ? 'text-tcolor dark:text-gray-200' : 'text-gray-600 dark:text-gray-400'}`} onMouseEnter={() => c.extendSidebar === false ? '' : setHighlighted(c.title)} onClick={() => setHighlighted(c.title)} title={t(c.subtitle)}>
                                                        <c.TitleIcon size="22px" className={`my-3`} />
                                                    </motion.span>
                                                </Link>
                                            )
                                           }
                                        }
                                    } return null;
                                })
                            }
                        </div>
                         }
                        <motion.span variants={TextAnimateY}>
                            <div className="inline-block mb-7 mr-1">
                                <ReportSelector injectPopupClass="left-12 top-0" originX="left" originY="top" onFocus={expandSideBar} selectCallBack={selectCallBack}/>
                            </div>
                        </motion.span>
                        {userDetails.role && (userDetails.role.length === 1 && userDetails.role.includes('developer')) ? '' :<motion.span variants={TextAnimateY}>
                            <div className="inline-block mb-8 mr-2">
                                <OrganizationSelector injectPopupClass="left-12 top-0" originX="left" originY="top" onFocus={expandSideBar} selectCallBack={selectCallBack} closeOrg={closeOrg}/>
                            </div>
                        </motion.span>}
                        <motion.span variants={TextAnimateY}>
                            <div className="inline-block mb-8 mr-2">
                                <LanguageChange injectPopupClass="left-12 top-0" originX="left" originY="top" onFocus={expandSideBar} onBlur={shrinkSideBar} selectCallBack={selectCallBack} closeLanguage={closeLanguage}/>
                            </div>
                        </motion.span>
                        <motion.span variants={TextAnimateY}>
                            <div className="transform rotate-90 inline-block mb-8 mr-2">
                                <DarkModeSwitch rotate="270" onFocus={expandSideBar} selectCallBack={selectCallBack} />
                            </div>
                        </motion.span>
                        <motion.span variants={TextAnimateY} className="flex my-2 justify-center cursor-pointer group relative text-white mb-12" tabIndex='0' onKeyDown={(event) =>event.key === "Enter" && logout()} onClick={logout} title={t("Logout")}>
                            <GoSignOut size="25px" className="text-gray-600 dark:text-gray-400 group-hover:animate-pulse" />
                        </motion.span>
                        <motion.span variants={TextAnimateXRev} className={`hidden lg:flex my-2 justify-center cursor-pointer group absolute -bottom-10 right-1 text-white mb-12 bg-bluegray-300 dark:bg-bluegray-700 rounded-full`} tabIndex="0" onBlur={() =>shrinkSideBar() }  onClick={() => sideBarExpanded ? shrinkSideBar() : expandSideBar()}>
                            <span className={`transform transition-all duration-200 ${sideBarExpanded ? 'rotate-180' : ''}`}>
                                <MdKeyboardArrowRight size="20px" className={`text-gray-600 dark:text-white group-hover:animate-pulse`} />
                            </span>
                        </motion.span>
                    </div>
                    <div className={`flex flex-col bg-bluegray-200 dark:bg-ddark w-full pb-10 pt-5 px-2 overflow-y-auto overflow-x- ${sideBarExpanded ? 'block' : 'lg:hidden'}`} ref={linkRefs}>
                        <div className="mb-5 text-blue-500 dark:text-yellow-600 text-sm font-bold">
                            <FlowText text={t((parseInt(organization) !== userDetails.orgId && userDetails.role.includes('dynamic_scr') && sideMenuList.title === undefined) ? '' :selectedMainMenu.title)} />
                        </div>
                        {
                            sideMenuList.length > 0 && sideMenuList.map((c, i) => {
                                if(((c.title === 'User List' || c.title === 'Organization Details' || c.title === 'Associated Orgs') && parseInt(organization) !== userDetails.orgId && (userDetails.role.includes('admin')||userDetails.role.includes('dynamic_admin')))|| (upload == 'true' && (c.title === 'Uploads') && parseInt(organization) !== userDetails.orgId && (userDetails.role.includes('admin')||userDetails.role.includes('dynamic_admin')))  || ((c.title === 'Enroll Caregiver') && parseInt(organization) !== userDetails.orgId && userDetails.role.includes('dynamic_cm')) || ((c.title === 'Create Referral') && parseInt(organization) !== userDetails.orgId && userDetails.role.includes('dynamic_ref')) || ((c.title === 'Add Service Usage Data') && parseInt(organization) !== userDetails.orgId && (service === 'true') && (userDetails.role.includes('dynamic_admin') || userDetails.role.includes('dynamic_cm'))) || (c.title === 'To Do' && parseInt(organization) !== userDetails.orgId && userDetails.role.includes('dynamic_cm'))|| (c.title === 'Closed Cases' && parseInt(organization) !== userDetails.orgId && (userDetails.role.includes('dynamic_cm') || userDetails.role.includes('admin') || userDetails.role.includes('dynamic_admin') || userDetails.role.includes('dynamic_ref'))) || ((c.title === 'Unassigned Cases'||c.title === 'Watch List') && parseInt(organization) !== userDetails.orgId && (userDetails.role.includes('admin') || userDetails.role.includes('dynamic_cm') || userDetails.role.includes('dynamic_admin')))||(c.title === 'Pending Referrals' && parseInt(organization) !== userDetails.orgId && (userDetails.role.includes('dynamic_cm') || userDetails.role.includes('dynamic_admin') || userDetails.role.includes('dynamic_ref') || userDetails.role.includes('admin'))) || ((c.title === 'Subscriber ID Details') && parseInt(organization) !== userDetails.orgId && (userDetails.role.includes('dynamic_scr')) && noCaregiver === 'true') || ((c.title === 'Care Receivers') && parseInt(organization) !== userDetails.orgId && (userDetails.role.includes('dynamic_scr')) && noCaregiver === 'true')){
                                    return (
                                        <Link key={`${i}`} to={c.link} className="block z-10 my-1 text-left" ref={((el)=>el !== null && (linkRefs.current[i] = el))}
 onKeyDown ={(event) => handleKeyDown(event,i)}>
                                            <motion.span  variants={TextAnimateY} className={`flex items-center py-1 pl-2 hover:rounded hover:bg-tcolor dark:hover:bg-gray-500 cursor-pointer hover:text-white dark:hover:text-blue-200 text-xs ${history.location.pathname === c.link ? 'text-tcolor font-bold' : 'text-gray-600 dark:text-gray-300'}`}>
                                                <c.ItemIcon size="14px" className="mr-2" />
                                                {t(c.title)}
                                            </motion.span>
                                        </Link>
                                    )
                                }else if(((c.title === 'User List'|| c.title === 'Organization Details' || c.title === 'Associated Orgs') &&  parseInt(organization) === userDetails.orgId && userDetails.role.includes('admin')) || ((c.title === 'Uploads') &&  parseInt(organization) === userDetails.orgId && userDetails.role.includes('admin') && upload === 'true') || ((c.title === 'Enroll Caregiver') && parseInt(organization) === userDetails.orgId && (userDetails.role.includes('caremanager'))) || ((c.title === 'Create Referral') && parseInt(organization) === userDetails.orgId && userDetails.role.includes('referrer')) ||((c.title === 'Add Service Usage Data') && parseInt(organization) === userDetails.orgId && (service === 'true') && (userDetails.role.includes('admin') || userDetails.role.includes('caremanager'))) ||(c.title === 'To Do' && parseInt(organization) === userDetails.orgId && (userDetails.role.includes('caremanager'))) || (c.title === 'Closed Cases' && parseInt(organization) === userDetails.orgId && (userDetails.role.includes('caremanager') || userDetails.role.includes('admin'))) || (( c.title === 'Clients') && parseInt(organization) === userDetails.orgId && (userDetails.role.includes('screener')))  ||((c.title === 'Unassigned Cases'||c.title === 'Watch List') && parseInt(organization) === userDetails.orgId && (userDetails.role.includes('caremanager') || userDetails.role.includes('admin'))) ||(c.title === 'Pending Referrals'&& parseInt(organization) === userDetails.orgId && (userDetails.role.includes('caremanager') || userDetails.role.includes('admin') || userDetails.role.includes('referrer'))) || ((c.title === 'Subscriber ID Details') && parseInt(organization) === userDetails.orgId && (userDetails.role.includes('screener')) && noCaregiver === 'true') || ((c.title === 'Care Receivers') && parseInt(organization) === userDetails.orgId && (userDetails.role.includes('screener')) && noCaregiver === 'true')){
                                    return (
                                        <Link key={`${i}`} to={c.link} className="block z-10 my-1 text-left" ref={((el)=>el !== null && (linkRefs.current[i] = el))}
 onKeyDown ={(event) => handleKeyDown(event,i)}>
                                            <motion.span  variants={TextAnimateY} className={`flex items-center py-1 pl-2 hover:rounded hover:bg-tcolor dark:hover:bg-gray-500 cursor-pointer hover:text-white dark:hover:text-blue-200 text-xs ${history.location.pathname === c.link ? 'text-tcolor font-bold' : 'text-gray-600 dark:text-gray-300'}`}>
                                                <c.ItemIcon size="14px" className="mr-2" />
                                                {t(c.title)}
                                            </motion.span>
                                        </Link>
                                    )
                                }  else{
                                   if(c.title !== 'User List' && c.title !== 'Organization Details' && c.title !== 'Uploads' && c.title !== 'Associated Orgs' && c.title !== 'Enroll Caregiver' && c.title !== 'Create Referral' && c.title !== 'To Do' && c.title !== 'Closed Cases' && c.title !== 'Unassigned Cases' && c.title !== 'Watch List' && c.title !== 'Pending Referrals' && c.title !== 'Subscriber ID Details' && c.title !== 'Care Receivers' && c.title !== 'Add Service Usage Data'){
                                    return (
                                        <Link key={`${i}`} to={c.link} className="block z-10 my-1 text-left" ref={((el)=>el !== null && (linkRefs.current[i] = el))}
 onKeyDown ={(event) => handleKeyDown(event,i)}>
                                            <motion.span  variants={TextAnimateY} className={`flex items-center py-1 pl-2 hover:rounded hover:bg-tcolor dark:hover:bg-gray-500 cursor-pointer hover:text-white dark:hover:text-blue-200 text-xs ${history.location.pathname === c.link ? 'text-tcolor font-bold' : 'text-gray-600 dark:text-gray-300'}`}>
                                                <c.ItemIcon size="14px" className="mr-2" />
                                                {t(c.title)}
                                            </motion.span>
                                        </Link>
                                    )
                                   
                                   }
                                }
                                return null;
                            })
                        }
                        {/* <img src={highlighted === 'Content' ? img1 : img2} alt="Sidebar Bg logo" aria-label='Sidebar Bg logo' role="presentation" className="absolute bottom-0 opacity-5 w-64 mb-5" /> */}
                        <div className="pb-5"></div>
                    </div>
                </motion.div>
                <Dialog title='Add Carereceivers' showDialog={addReferralDialog} onClose={() => setAddReferralDialog(false)}>
                    <AddReferral onClose={() => setAddReferralDialog(false)} />
                </Dialog>
            </div>
        </>
    )
}

export default withRouter(SideBar)